import moment from "moment";

function formateMesAno(date) {
    let dateFormated = date;
    dateFormated = moment(date).format('MM/YYYY');
    return dateFormated;
}

function formateDate(date) {
    let dateFormated = date;
    dateFormated = moment(date).format('DD/MM/YYYY');
    return dateFormated;
}

function formateDateApi(date) {
    let dateFormated = date;
    dateFormated = moment(date).format('YYYY-MM-DD');
    return dateFormated;
}

function formateDateApi2(date) {
    let dateFormated = date;
    dateFormated = moment(date).format('DD/MM/YYYY');
    return dateFormated;
}

function formateDateAndTimeApi(date) {
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().replace(/\..+/, '')
}

function formateDateandTime(date) {
    let dateFormated = date;
    dateFormated = moment(date).format('DD/MM/YYYY HH:mm');
    return dateFormated;
}

function formateDateByMesAno(value) {
    return moment("01/" + value, "DD/MM/YYYY").toDate();
}
function formateDateByMesAno2(value) {
    const parts = value.split('/');
    const month = parts[0];
    const year = parts[1];
  
    const lastDayOfMonth = new Date(year, month, 0).getDate();
    const day = lastDayOfMonth < 10 ? '0' + lastDayOfMonth : lastDayOfMonth;
  
    return moment(`${day}/${value}`, 'DD/MM/YYYY').toDate();
  }
  

function formateCurrencyInput(value) {
    if (value || value == 0)
        return parseFloat(value).toFixed(2);
    else
        return "";
}

function formateCurrencyApi(value) {
    if (value)
        return value.replace(",", ".");
    else
        return null;
}
function formateCurrencyValueApi(value) {
    if (value)
        return value.replace(",", ".");
    else
        return 0;
}

function formateMonthName(mesAno) {
    let split = mesAno.split('/');
    let mes = parseInt(split[0], 10);
    let ano = parseInt(split[1], 10);

    let meses = [
        'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
        'jul', 'ago', 'set', 'out', 'nov', 'dez'
    ];

    let nomeMes = meses[mes - 1];
    let anoFormatado = ano.toString().slice(-2); // Obter os dois últimos dígitos do ano

    return `${nomeMes}/${anoFormatado}`;
}

export {
    formateDate,
    formateDateandTime,
    formateDateApi,
    formateDateApi2,
    formateDateAndTimeApi,
    formateMesAno,
    formateDateByMesAno,
    formateDateByMesAno2,
    formateCurrencyInput,
    formateCurrencyApi,
    formateCurrencyValueApi,
    formateMonthName
};